<template>
  <div>
    <v-treeview
      v-model="treeview"
      :items="items"
      class="pa-0"
      :load-children="getChildrenData"
    >
      <template v-slot:prepend="{ item, open }">
        <v-icon v-if="item.type == 'workspace'">
          {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
        </v-icon>
        <v-icon v-else>
          {{ item.icon }}
        </v-icon>
      </template>
      <template v-slot:append="{ item }">
        <v-icon
          color="primary"
          v-if="item.type == 'layer'"
          title="Thêm lớp lên bản đồ"
          :disabled="layerIdSelect.includes(item.info.id)"
          @click="onAddLayer(item)"
        >
          mdi-plus
        </v-icon>
        <v-icon
          color="primary"
          v-else-if="item.type == 'layergroup'"
          title="Thêm lớp lên bản đồ"
          :disabled="layerGroupIdSelect.includes(item.info.id)"
          @click="onAddLayerGroup(item)"
        >
          mdi-plus
        </v-icon>
      </template>
    </v-treeview>
  </div>
</template>

<script>
import { API_LAYER, API_LAYERGROUP, API_WORKSPACE } from '@api'

export default {
  components: {},
  props: {
    settings: {},
    layerIdSelect: { type: Array, default: () => [] },
    layerGroupIdSelect: { type: Array, default: () => [] },
  },
  data: () => ({
    form: { layers: [], styles: [] },
    workspace: { items: [], loading: true },
    treeview: [],
    items: [],
  }),
  computed: {
    isGlobalWMSOff() {
      return (
        this.settings &&
        this.settings.data &&
        !this.settings.data.is_global_enable
      )
    },
    wkCanUseIds() {
      return this.settings.data.workspaces_enabled.map((x) => x.id)
    },
    wkDisableIds() {
      return this.settings.data.workspaces_disabled.map((x) => x.id)
    },
    apiLayerSearch() {
      return API_LAYER
    },
  },
  created() {
    this.workspace.loading = true
    API_WORKSPACE.list({ with_count: true, sort: 'name' })
      .then((res) => {
        this.workspace.items = this.filterWk(res.data)
        this.items = this.workspace.items.map((x) => {
          let result = {
            id: x.id,
            name: x.name,
            type: 'workspace',
          }
          if (x.maps_count + x.layers_count > 0) {
            result.children = []
            if (x.layers_count > 0) {
              result.children.push({
                id: `${x.id}-layer`,
                name: 'Lớp bản đồ',
                type: 'layer-parent',
                children: [],
                icon: 'mdi-layers',
                workspace_id: x.id,
                info: x,
                disabled: x.layers_count < 1,
              })
            }
            if (x.maps_count > 0) {
              result.children.push({
                id: `${x.id}-layergroup`,
                name: 'Bản đồ',
                type: 'map-parent',
                children: [],
                icon: 'mdi-map',
                workspace_id: x.id,
                info: x,
                disabled: x.maps_count < 1,
              })
            }
          } else {
            result.disabled = true
            result.children = [
              {
                id: `${x.id}-nodata`,
                name: 'Không có dữ liệu',
                type: 'nodata-parent',
                workspace_id: x.id,
                disabled: true,
              },
            ]
          }
          return result
        })
      })
      .finally(() => {
        this.workspace.loading = false
      })
  },
  methods: {
    filterWk(items) {
      if (this.isGlobalWMSOff) {
        return items.filter((x) => this.wkCanUseIds.includes(x.id))
      } else {
        return items.filter((x) => !this.wkDisableIds.includes(x.id))
      }
    },
    onAddLayer(layer) {
      layer.selected = true
      this.$emit('click:add', { layers: [layer.info], styles: [] })
    },
    onAddLayerGroup(layergroup) {
      this.$emit('click:add-layer-group', {
        layerGroups: [layergroup.info],
      })
    },
    async getChildrenData(item) {
      if (item.type == 'layer-parent') {
        let res = await API_LAYER.list({
          workspace_id: item.workspace_id,
          is_publish: true,
          sort: 'name',
          with: 'workspace,style,datastoreDetail.fields',
        })
        item.children = res.data.map((x) => {
          x.workspace = item.info
          return {
            id: x.id,
            name: x.name,
            type: 'layer',
            info: x,
          }
        })
      } else if (item.type == 'map-parent') {
        let res = await API_LAYERGROUP.list({
          workspace_id: item.workspace_id,
          sort: 'name',
        })

        item.children = res.data.map((x) => {
          x.workspace = item.info
          return {
            id: x.id,
            name: x.name,
            type: 'layergroup',
            info: x,
          }
        })
      }
    },
  },
}
</script>

<style scoped></style>
